export default __webpack_public_path__ + "static/media/admin-tags.cba20756.svg";